import axios, { AxiosError } from "axios";
import { env } from "next-runtime-env";

const Api = axios.create({
  baseURL: env("NEXT_PUBLIC_API_REMIT_URL"), // YOUR_API_URL HERE
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
  },
});

Api.interceptors.response.use(
  (res) => res,
  (err: AxiosError<any>) => {
    return Promise.reject(err);
  }
);

export default Api;
